import type { ComponentPropsWithRef } from 'react';

import type { lineHeight } from '~/styles/constants.css';
import type { fontSize } from '~/styles/contracts.css';

import { clsx } from '~/styles/utils';

import {
  skeletonInnerTextStyle,
  skeletonTextFontSizeStyles,
  skeletonTextLineHeightStyles,
  skeletonTextStyle,
  skeletonTextWidthStyles,
} from './SkeletonText.css';

type Props = ComponentPropsWithRef<'div'> & {
  fontSize?: keyof typeof fontSize;
  lineHeight?: keyof typeof lineHeight;
  width?: '10%' | '20%' | '30%' | '40%' | '50%' | '60%' | '70%' | '80%' | '90%' | '100%';
};

export const SkeletonText = ({ fontSize = 'regular', lineHeight = 'normal', width = '100%', ...delegated }: Props) => {
  return (
    <div
      {...delegated}
      className={clsx(
        skeletonTextStyle,
        skeletonTextWidthStyles[width],
        skeletonTextFontSizeStyles[fontSize],
        skeletonTextLineHeightStyles[lineHeight],
        delegated.className,
      )}
    >
      <div className={skeletonInnerTextStyle} />
    </div>
  );
};
